import { createAction } from 'redux-actions';

export const postJoinWaitlistRequest = createAction('POST_JOIN_WAITLIST_REQUEST');
export const postJoinWaitlistCheck = createAction('POST_JOIN_WAITLIST_CHECK');
export const postJoinWaitlistSuccess = createAction('POST_JOIN_WAITLIST_SUCCESS');
export const postJoinWaitlistFail = createAction('POST_JOIN_WAITLIST_FAIL');
